import * as StyleFunctions from './StyleFunctions';
import LevenshteinText from '../LevenshteinText';
import * as CoreFns from './CoreFns';
import * as TypeEvaluation from '../TypeEvaluation';
import * as TreeFunctions from './TreeFunctions';

export function getMaxPosition(currentList){
  var maxPositionX = null;
  
  function getMaxPositions(fe){
    var keys = Object.keys(fe);
    keys.forEach((aKey, index)=>{
      var thisPiece = fe[aKey];
      if (thisPiece.pos){
        var xP = thisPiece.pos.xP;
        if (maxPositionX === null || xP > maxPositionX){
          maxPositionX = xP;
          maxPositionX = xP;
        }
      }
    })
  }

  getMaxPositions(currentList.fe);
  getMaxPositions(currentList.pu);  

  if (maxPositionX === null){
    maxPositionX = -1;
  }

  return maxPositionX + 1;  
}

export function isRelative(path){
    if (path[0] === 'fo'){
      if (path[1] === 'k' || path.length > 3){
        return true;
      }
    }else if (path[0] === 'fe' || path[0] === 'pu'){
      if (path[4] === 'k' || path.length > 6){
        return true;
      }
    }
    return false;
  }

export function addWhereFromItem(item, addW){
  if (item.t === 'CARD' || item.t === 'HFLEX' || item.t === 'CONTAINER' || item.t === 'SUMMARY' || item.t === 'TABLE' || item.t === 'TR' || item.t === 'TABS' || item.t === 'TABITEM' || item.t === 'TD' || item.t === 'navDropDown'){
    return item.t;
  }else{
    return addW;
  }
}

function figureOutAddWhereFromAddPath(currentList, addPath){
  if (addPath.length === 4 && addPath[2] === 'nv'){
    return 'navBar';
  }else if (addPath.length === 2 && addPath[0] === 'fo'){
    return 'FOOTER';
  }else if (addPath.length === 5){
    return 'PANEL';
  }else{
    var itemScreenPath1 = CoreFns.filterPathStopBefore(addPath, addPath.length - 1);
    if (CoreFns.isAlert(itemScreenPath1)){
      return 'ALERT';
    }
    var parentItem = CoreFns.goDownPath(currentList, itemScreenPath1);
    return addWhereFromItem(parentItem, '');
  }

}

function findHighestZ(addPath, currentList){
  var residents = CoreFns.goDownPath(currentList, addPath);
  var max = -1;
  var residentKeys = Object.keys(residents);
  residentKeys.forEach((aKey, index)=>{
    var thisResident = residents[aKey];
    var s = thisResident.s;
    if (s){
      var zIndex = s.zIndex;
      if (zIndex){
        var thisZIndex = +zIndex;
        if (thisZIndex > max){
          max = thisZIndex;
        }
      }
    }
  })
  return (max + 1) + '';
}

export function is12Width(addWhat){
  return addWhat === 'TIMER' || addWhat === 'LINECHART' || addWhat === 'SUMMARY' || addWhat === 'GALLERY' || addWhat === 'TABS';
}

export function reallyAddItem(item, addPath, uuid, position, currentList, organicChanges, asChanges, setItemEdited, insetWidth, insetHeight, setIsShowingSomeDropDown, hidePanelRelativeItems, setHidePanelRelativeItems){
    var addWhereText = figureOutAddWhereFromAddPath(currentList, addPath);

    if (addPath.length > 3 && addPath[2] === 'nv' && addPath[0] === 'fe'){
      try{
        var navPathSet = CoreFns.goDownPath(currentList, ['fe', addPath[1], addPath[2]]);
        if (navPathSet && navPathSet.on && navPathSet.on !== 1){
          var startPath = ['cn', navPathSet.on, 'nv'];
          for (var i = 3; i < addPath.length; i++){
            startPath.push(addPath[i]);
          }
          addPath = startPath;
        }

      }catch(err){

      }
    }

    if (is12Width(item.t)){
      item.s.colWidth = {t:'bsu',v:12};
    }

    var ord = 0;
    if (addWhereText === 'CARD' || addWhereText === 'CONTAINER' || addWhereText === 'HFLEX' || addWhereText === 'navBar' || addWhereText === 'SUMMARY' || addWhereText === 'TABLE' || addWhereText === 'TR' || addWhereText === 'TD' || addWhereText === 'TABS' || addWhereText === 'TABITEM' || addWhereText === 'navDropDown' ){
      ord = getNextOrd(currentList, addPath);
      item.s.ord = {t:'int',v:ord};

    }else if (addWhereText === 'PANEL' || addWhereText === 'FOOTER'){
      if (!position){
        ord = getNextOrd(currentList, addPath);
        item.s.ord = {t:'int',v:ord};
      }else{
        item.s.zIndex = findHighestZ(addPath, currentList);
        var left = 100 * position.left / insetWidth;
        var top = 100 * position.top / insetHeight;
        var pos = {};
        if (item.t === 'SUMMARY'){
          pos = {l:{t:'vw', v:left},t:{t:'vh', v:top},w:{t:'vw', v:90},ud:{t:'int',v:0}, h:{t:'vh', v:50}, lr:{t:'int',v:0}};
        }else{
          pos = {l:{t:'vw', v:left},t:{t:'vh', v:top},w:{t:'vw', v:25}, lr:{t:'int',v:0}};
          if (item.t === 'HFLEX'){
            pos = {l:{t:'vw', v:left},t:{t:'vh', v:top}, r:{t:'vw', v:0}, lr:{t:'int',v:1}};
          } 
          if (item.t === 'IMG'){
            pos.ud = {t:'int',v:3};
          }else{
            pos.ud = {t:'int',v:0};
          }
          pos.h = {t:'vh', v:25};
        }
        item.pos = pos;

      }
    }


    if (ord > 0){
      setIsShowingSomeDropDown({t:'itemPosition'});
    }

    if (!position){
      var screenPart = CoreFns.filterPathStopBefore(addPath, 4);
      delete hidePanelRelativeItems[screenPart.join(' ')];
      setHidePanelRelativeItems({...hidePanelRelativeItems});
    }

    item._na = CoreFns.simplName(uuid);
    var changes = [{t:'w',w:addPath.concat([uuid]),n:item}].concat(asChanges);
    organicChanges(changes);
    var path = addPath.concat([uuid]);
    setItemEdited({t:'item', path});
    return path;    
}

export function getOrigFn(whatDrop, currentScreenStyle){
  var orig = false;
  if (currentScreenStyle){
    if (currentScreenStyle[whatDrop]){
      if (currentScreenStyle[whatDrop].t === 'formula' || currentScreenStyle[whatDrop].t === 'bsu'){
        return currentScreenStyle[whatDrop];
      }
      orig = currentScreenStyle[whatDrop].v;
    }
  }
  return orig;    
}


export function formulaPieceInGeneralX(pointer, title, type, organicChanges, stylePath, currentScreenStyle, addToExtraScreen){
    var currentColor = currentScreenStyle[pointer];
    var path = stylePath.concat([pointer]);

      if (!currentColor || currentColor.t !== 'formula'){
        var newP;
        if (type.t === 'Boolean'){
          if (currentColor){
            if (currentColor.t === 'int'){
              newP = {o:{i: 8, t: 'f', v: []}, x:[{t: 'f', v: 8}], y:{}};
            }
          }else{
            newP = {o:{i: 9, t: 'f', v: []}, x:[{t: 'f', v: 9}], y:{}};
          }
        }else if (type.t === 'Font Size'){

          var defaultSize = '1'; 
          var unitFormula = 62;
          if (currentColor){
            if (currentColor.t){
              if (currentColor.t === 'comb'){
                defaultSize = currentColor.v.var.v.toString();
              }else{
                defaultSize = currentColor.v.toString();
                if (currentColor.t === 'px'){
                  unitFormula = 63;
                }
              }
            }
          }
          newP = {o:{i: unitFormula, t: 'f', v:[{t: 'dc', v:defaultSize}]}, x:[{t: 'f', v: unitFormula}, {t: 'g', v: 'c1'}], y:{c1:{x:[{t: 'dc', v:defaultSize}]}}};
        }else if (type.t === 'Integer'){
          var defaultInt = '0'; 
          if (currentColor){
            if (currentColor.t === 'int'){
              defaultInt = '' + currentColor.v;
            }
          }
          newP = {o:{t: 'i', v:defaultInt}, x:[{t: 'i', v:defaultInt}], y: {}};
        }else if (type.t === 'UInteger' || type.t === 'Decimal'){
          var defaultUInt = '0'; 
          if (currentColor){
            if (currentColor.t === 'int'){
              defaultUInt = '' + currentColor.v;
            }
          }
          var ack = 'ui';
          if (type.t === 'Decimal'){
            ack = 'dc';
          }
          newP = {o:{t:ack, v:defaultUInt}, r:type, t: 'formula', x:[{t:ack, v:defaultUInt}], y: {}};
        }else if (type.t === 'Color'){
          if (currentColor){
            if (currentColor.t === 'raw'){
               var rgbSet = StyleFunctions.getRGBFromText(currentColor.v);
                newP = {o:{i: 27, t: 'f', v: [{t: 'i', v: ''+rgbSet.red}, {t: 'i', v: ''+rgbSet.green}, {t: 'i', v: ''+rgbSet.blue}]}, x: [{t: 'f', v: 27}, {t: 'g', v: 'c1'}, {t: 'g', v: 'c2'}, {t: 'g', v: 'c3'}],y: {c1:{x:[{t: 'i', v: ''+rgbSet.red}]}, c2:{x:[{t: 'i', v: ''+rgbSet.green}]}, c3:{x:[{t: 'i', v:''+rgbSet.blue}]}}};
            }
          }else{
            newP = {o:{i: 42, t: 'f', v: []}, x:[{t: 'f', v: 42}], y: {}};
          }

        }else if (type.t === 'Text String'){
          var defaultText = '1'; 
          if (currentColor){
            if (currentColor.t === 'raw'){
              defaultText = currentColor.v;
            }
          }
          newP = {o: {t: 's', v:defaultText},x:[{t:'s', v:defaultText}], y: {}};
        }
        if (newP){
          newP.r = type;
          newP.t = 'formula';
          var changes1 = [{t:'w',w:path, n:newP}];
          organicChanges(changes1);
        }
      }

      var changes = [];
      var x = [];
      var o;
      var y = {};

      if (type.t === 'ListType'){
        if (type.c.t === 'any'){
          o = {t: 'f', i: 60, v:[{t:'ui',v:'1'},{t:'ui',v:'2'}]};
          x = [{t:'f',v:60},{t:'g',v:'c1_1'},{t:'g',v:'c1_2'}];
          y = {c1_1:{x:[{t:'ui',v:'1'}]},c1_2:{x:[{t:'ui',v:'2'}]}}
        }
      }
      if (!currentScreenStyle[pointer]){
        var y1 = {t:'formula',x,r:type,y,o};
        changes = [{t:'w',w:path,n:y1}];
      }else if (!currentScreenStyle[pointer].x){
        changes = [{t:'w',w:path.concat(['x']),n:x},{t:'w',w:path.concat(['r']),n:type},{t:'w',w:path.concat(['y']),n:y}];
        if (o){
          changes.push({t:'w',w:path.concat(['o']),n:o})
        }
      }else if (currentScreenStyle[pointer].t !== 'formula'){
        changes = [{t:'w',w:path.concat(['t']),n:'formula'}];
      }
      if (changes){
        organicChanges(changes);      
      }

      addToExtraScreen({t:'responsiveEdit',title, path})

    
  }


export function isFormula(currentScreenStyle, formula, pointer){
    if (currentScreenStyle && formula){
      var val = currentScreenStyle[pointer];
      if (val){
        if (val.t === 'formula'){
          return true;
        }
      }
    }
    return false;
  }

export function stripOffLastItem(objPath){
  if (objPath.length === 0){
    return null;
  }
  var w = objPath.filter((anObjPath, index)=>{
    return +index < objPath.length - 1;
  })
  var ii = objPath[objPath.length - 1];
  return {priors:w, last:ii};  
}

export function sortAListBasedOnOrd(navBarItems){
  return sortAListBasedOnAStyle(navBarItems, 'ord');
}


export function sortAListBasedOnAStyle(navBarItems, aStyle){
  var x = function(a1, b1) {
    if (!navBarItems[a1].s[aStyle] || !navBarItems[b1].s[aStyle]){
      return -1;
    }
    if (navBarItems[a1].s[aStyle].v < navBarItems[b1].s[aStyle].v) {
      return -1;
    }
    if (navBarItems[a1].s[aStyle].v > navBarItems[b1].s[aStyle].v) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }
  if (navBarItems){
    var navItemKeys = Object.keys(navBarItems);
    if (navItemKeys.length > 1){
      return navItemKeys.sort(x);    
    }else{
      return navItemKeys;
    }
  }else{
    return [];
  }

}

export function sortAListBasedOnOrdNotStyle(navBarItems){
  return sortAListBasedOnNotStyle(navBarItems, 'ord');
}


export function sortAListBasedOnNotStyle(navBarItems, aStyle){
  var x = function(a, b) {
    if (navBarItems[a][aStyle] < navBarItems[b][aStyle]) {
      return -1;
    }
    if (navBarItems[a][aStyle] > navBarItems[b][aStyle]) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }

  var navItemKeys = Object.keys(navBarItems);
  return navItemKeys.sort(x);

}

export function smartContractsFn(currentList){
  return currentList.sc;
}

export function getNextOrd(currentList, navBarPath){
    var existingNavItems = CoreFns.goDownPath(currentList, navBarPath, 0);
    var maxOrd = -1;
    if (existingNavItems){
      var navItemKeys1 = Object.keys(existingNavItems);
      navItemKeys1.forEach((aKey, index)=>{
        var thisItem = existingNavItems[aKey];
        var thisItemOrd = thisItem.s.ord.v
        if (thisItemOrd > maxOrd){
          maxOrd = thisItemOrd;
        }
      })
    }
    return maxOrd + 1;
}

export function getNextOrdDirect(currentList, navBarPath){
    var existingNavItems = CoreFns.goDownPath(currentList, navBarPath, 0);
    var maxOrd = -1;
    if (existingNavItems){
      var navItemKeys1 = Object.keys(existingNavItems);
      navItemKeys1.forEach((aKey, index)=>{
        var thisItemOrd = existingNavItems[aKey].ord;
        if (thisItemOrd > maxOrd){
          maxOrd = thisItemOrd;
        }
      })      
    }
    return maxOrd + 1;
}


export function getContractAddr(currentList, contractKey){
  var thisSc = currentList.sc[contractKey];
  if (thisSc){
    var chainId = CoreFns.relevantChainId(currentList);
    return thisSc.addSet[chainId].addr;
  }
  return false;  
}

export function existingContractRelevantAbi(v, i, nosInputsString, currentList){
  var Abi = CoreFns.getContractInfoAbi(currentList, v);
  if (Abi){

      for (var i1 = 0; i1 < Abi.length; i1++){
        if (Abi[i1].name === i){
          if (nosInputsString === null || nosInputsString === undefined){
            console.warn('Contract function ' + Abi[i1].name + ' not in new format');
            return Abi[i1];
          }
          if (Abi[i1].inputs.length === +nosInputsString){
            return Abi[i1];
          }else{
            console.log(Abi[i1]);
            return Abi[i1];
          }
        }
      }
  }
  return false;  
}
export function getToRelevantAbi(firstNode, currentList){
  var iParts = firstNode.i.split(' ');
  return existingContractRelevantAbi(firstNode.s, iParts[0], iParts[1], currentList);
}

function updateType(type, goDown, currentList){
  if (!goDown || goDown.i === 'all'){
    return type;
  }
  if (type.t === 'ListType'){
    return updateType(type.c, goDown.subs.aspect, currentList);
  // }else if (type.t === 'Mapping'){
  //   return updateType(type.c, goDown.subs.aspect, currentList);
  // }else if (type.t === 'Struct'){
  //   var childrenSet = childrenOfAStruct(currentList, type.v);
  //   if (childrenSet){
  //     var thisChild = childrenSet.functions[goDown.i];
  //     if (thisChild){
  //       return updateType(CoreFns.convertSelectionToType(thisChild.t, currentList), goDown.subs.aspect, currentList);
  //     }
  //   }
  }
  return false;
}

function getVariableType(sss, currentList){
  if (sss){
    if (sss.indexOf('ov_') === 0){
      var thisOV = currentList.ov[sss.substr(3)];
      if (thisOV){
        return CoreFns.convertSelectionToType(thisOV.t, currentList);
      }
    }
  }
  return {t:'toDelete'};
}


function figureOutGoDown(type, cVariables){
  if (type.t === 'ListType' || type.t === 'Object'){
    cVariables.push({q:'Variable Aspect',t:{t:'GoDown',v:type},i:'aspect'})
  }
}



export function getQuestionsOfACurrentAnswer(currentList, screenPath, currentAnswerSet, chains, changeTab){
  var currentAnswer = currentAnswerSet.t;
    if (currentAnswer === 'connectWallet' || currentAnswer === 'hideOwnBanner' || !currentAnswer || currentAnswer === 'reloadDapp'){
      return [];
    }else if (currentAnswer === 'alert'){
      return  [
        {q:'Message', t:{t:'Text String'}, i:'msg', f:1, c:[]},
        {q:'Next Action', t:{t:'Action'}, i:'next', c:[]},
      ];
    }else if (currentAnswer === 'scrollToPanel'){
      return [
        {q:'Which Panel', t:{t:'Panel'}, i:'panel', f:aPanel(screenPath), c:[]},
        {q:'Next Action', t:{t:'Action'}, i:'next', c:[]},
      ];
    }else if (currentAnswer === 'scrollToTop'){
      return  [{q:'Next Action', t:{t:'Action'}, i:'next', c:[]}];
    }else if (currentAnswer === 'delay'){
      return [
        {q:'Delay amount (in seconds)', t:{t:'Decimal'}, i:'amt', f:1, c:[]},
        {q:'Next Action', t:{t:'Action'}, i:'next', c:[]},
      ];
    }else if (currentAnswer === 'toggleBannerVisibility'){
      return  [
        {q:'Which Banner', t:{t:'Alert'}, i:'alert', f:anAlert(currentList, screenPath), c:[]},
        {q:'Visible', t:{t:'Boolean'}, i:'visibility', f:{t:'formula', x:[{t:'f',v:9,}], o:{t:'f',i:9,v:[]}, r:{t:'Boolean'},y:{}}, c:[]},
        {q:'Next Action', t:{t:'Action'}, i:'next', c:[]},
      ];
    }else if (currentAnswer === 'openPopUp'){
      return  [
        {q:'Which Pop Up', t:{t:'PopUp'}, i:'popUp', f:aPopUp(currentList), c:[]},
        {q:'Next Action', t:{t:'Action'}, i:'next', c:[]},
      ];
    }else if (currentAnswer === 'closePopUp'){
      return [
        {q:'Next Action', t:{t:'Action'}, i:'next', c:[]},
      ];
    }else if (currentAnswer === 'copyText'){
      return  [
        {q:'Text', t:{t:'Text String'}, i:'text', f:1, c:[]},
        {q:'Next Action', t:{t:'Action'}, i:'next', c:[]},
      ];
    }else if (currentAnswer === 'openUrl'){
      return [
        {q:'Url', t:{t:'Text String'}, i:'url', f:1, c:[]},
      ];
    }else if (currentAnswer === 'changeScreen'){
      return  [
        {q:'Which Page', t:{t:'Screen'}, i:'v', f:changeOfScreen(currentList, screenPath), c:[]},
        {q:'Next Action', t:{t:'Action'}, i:'next', c:[]}
      ];
    }else if (currentAnswer === 'toggleMusic'){

      var nosMusic = 0;
      if (currentList && currentList.mu){
        nosMusic = Object.keys(currentList.mu).length;
      }

      if (nosMusic > 0){
        return  [
          {q:'Which Music', t:{t:'Music'}, i:'v', f:changeOfMusic(currentList), c:[]},
          {q:'Next Action', t:{t:'Action'}, i:'next', c:[]}
        ];        
      }else{
        function goToMusicSelect(e){
          changeTab('Overall', 3);
        }
        return  [
          {q:'Add Music', t:{t:'Execute', ic:'material-symbols:add', f:goToMusicSelect}},
        ];        
      }
    // }else if (currentAnswer === 'writeToDatabase'){
    //   return [
    //     {q:'Value to Write', t:{t:'Text String'}, i:'v', f:1, c:[]},
    //     {q:'Next Action', t:{t:'Action'}, i:'next', c:[]}
    //   ];
    }else if (currentAnswer === 'prompt'){
      return  [
        {q:'Question', t:{t:'Text String'}, i:'msg', f:1, c:[]},
        {q:'Default Input', t:{t:'Text String'}, i:'default', f:1, c:[]},
        {q:'Next Action', t:{t:'Action'}, i:'Post_Prompt', c:[]},
        {q:'If Cancel', t:{t:'Action'}, i:'If_Cancel', c:[]},
      ];
    }else if (currentAnswer === 'placeholder'){
      return  [
        {q:'Prompt', t:{t:'Text String'}, i:'prompt', h:'Text String', c:[]}
      ];
    }else if (currentAnswer === 'confirm'){
      return [
        {q:'Question', t:{t:'Text String'}, i:'msg', f:1, c:[]},
        {q:'If Confirm', t:{t:'Action'}, i:'If_Confirm', c:[]},
        {q:'If Deny', t:{t:'Action'}, i:'If_Deny', c:[]},
      ];
    }else if (currentAnswer === 'ifThenElse'){
      return [
        {q:'Condition', t:{t:'Boolean'}, i:'cond', f:1, c:[]},
        {q:'If True', t:{t:'Action'}, i:'If_True', c:[]},
        {q:'If False', t:{t:'Action'}, i:'If_False', c:[]},
      ];
    }else if (currentAnswer === 'listPush' || currentAnswer === 'listRemoveItem' || currentAnswer === 'listRemoveIndex'){
      var cVariables1 = [{q:'List', a:'carbon:value-variable', t:{t:'Variable', type:{t:'ListType', c:{t:'any'}}}, i:'var', c:[]}];
      if (currentAnswer === 'listPush' || currentAnswer === 'listRemoveItem'){
        var sss1 = currentAnswerSet.var;
        if (sss1){
          var tt1 = getVariableType(sss1, currentList);
          var goDown1 = currentAnswerSet.aspect;
          var ttOut1 = updateType(tt1, goDown1, currentList);
          if (ttOut1 && ttOut1.c){
            if (currentAnswer === 'listPush'){
              cVariables1.push({q:'Value to Push',t:ttOut1.c,f:1,i:'newVal', c:[]});
            }else if (currentAnswer === 'listRemoveItem'){
              cVariables1.push({q:'Value to Remove',t:ttOut1.c,f:1,i:'newVal', c:[]});
              cVariables1.push({q:'Number of occurences to remove', t:{t:'Boolean', v:3, yesIcon:'material-symbols:all-inclusive', yesAnswer:'All', noIcon:'material-symbols:counter-1', noAnswer:'One'}, i:'nosToRemove', c:[]})
            }
          }
        }    
      }else if (currentAnswer === 'listRemoveIndex'){
        cVariables1.push({q:'Index to Remove (count starts from zero)',t:{t:'UInteger'},f:1,i:'indexToRemove', c:[]});
        cVariables1.push({q:'Start position', t:{t:'Boolean', v:3, yesIcon:'material-symbols:line-start-diamond-outline', yesAnswer:'Start of List', noIcon:'material-symbols:line-end-diamond-outline', noAnswer:'End of List'}, i:'startPoint', c:[]})
      }
      return cVariables1;
    }else if (currentAnswer === 'updateVar'){

      var cVariables = [{q:'Variable', a:'carbon:value-variable', t:{t:'Variable', type:{t:'any'}}, i:'var', c:[]}];
      var sss = currentAnswerSet.var
      if (sss){
        var tt = getVariableType(sss, currentList);
        var goDown = currentAnswerSet.aspect;
        var ttOut = updateType(tt, goDown, currentList);
        figureOutGoDown(tt, cVariables);
        if (ttOut){
          cVariables.push({q:'New Value',t:ttOut,f:1,i:'newVal', c:[]});
        }
      }

      return cVariables;

    }else if (currentAnswer.indexOf('changeInputValue') === 0){
      var item;
      try{
        var path = currentAnswer.substr(16).split(' ');
        item = CoreFns.goDownPath(currentList, path);
        if (!item){
          return false;
        }
      }catch(err){
        return false;
      }
      var vS = getDefaultTypeAndPointerFromItem(item);
      return [{q:'New Value', t:vS.iT, i:vS.i, f:1, c:[]},{q:'Next Action', t:{t:'Action'}, i:'Post_Change_Value', c:[]}];
    }else if (currentAnswer.indexOf('existingContractFn ') === 0 ){
        
      var parts = currentAnswer.split(' ');
      var tree = [];
      if (currentAnswer.indexOf('existingContractFn ') === 0){
        if (!checkThatSmartContractExists(currentList, parts[1])){
          return []; // we don't use false here because we want the error to show up as a placeholder warning.
        }
        var relevantAbi1 = existingContractRelevantAbi(parts[1], parts[2], parts[3], currentList);
        if (relevantAbi1){

          var contractInfo = CoreFns.getContractInfo(currentList, parts[1]);

          var inputs1 = relevantAbi1.inputs;
          tree = inputs1.map((anInput, index)=>{


            var start = 'Notes for ' + anInput.name + ' : ';
            var hint = '';
            if (contractInfo){
              var detailsTextListSet = TreeFunctions.getComments(contractInfo, {t:'function', nos:parts[2]});
              if (detailsTextListSet){
                for (var i9 = 0; i9 < detailsTextListSet.textList.length - 1; i9++){
                  if (detailsTextListSet.textList[i9].indexOf(start) === 0){
                    hint = detailsTextListSet.textList[i9].substr(start.length);
                    break;
                  }
                }
              }
            }

            var type1 = TypeEvaluation.convertSCTypeToInternalType(anInput);
            return {q:anInput.name, t:type1, h:hint, i:anInput.name, f:1, c:[]};
          })
        }else{
          return false;
        }
        if (relevantAbi1.stateMutability === 'payable'){
          var currencySym1 = CoreFns.currencySymbolOfDatabase(currentList, chains);
          tree.push({q:'Payable Amount in ' + currencySym1 + ' (i.e. 1 = 1 ' + currencySym1 + ')', t:{t:'Decimal'}, f:1, i:'_0', c:[]});
        }
      }else{
        if (parts[2] === 'stake'){
          tree.push({q:'Stake Amount (for Native Currency)', t:{t:'Decimal'}, f:1, i:'0', c:[]});
          tree.push({q:'Stake Amount (for Coins)', t:{t:'UInteger'}, f:1, i:'_stakeAmt', c:[]});
          // tree.push({q:'TokenID to Stake (for NFTs)', t:{t:'UInteger'}, f:1, i:'_tokenId', c:[]});
        }else if (parts[2] === 'unstake'){
          tree.push({q:'Unstake Amount (for Native Currency or Coins)', t:{t:'UInteger'}, f:1, i:'_unstakeAmt', c:[]});
        }else if (parts[2] === 'withdrawReferral'){
          tree.push({q:'Withdrawal Amount', t:{t:'UInteger'}, f:1, i:'_amt', c:[]});
        }else if (parts[2] === 'addReferralAddress'){
          tree.push({q:'Referral Address', t:{t:'Address'}, f:1, i:'_referringAddress', c:[]});
        }else if (parts[2] === 'exchange1To2' || parts[2] === 'exchnage2To1'){
          tree.push({q:'Exchange Amount (for Native Currency)', t:{t:'Decimal'}, f:1, i:'_0', c:[]});
          tree.push({q:'Exchange Amount (for Coins)', t:{t:'UInteger'}, f:1, i:'v0', c:[]});
        }
      }

      tree.push({q:'If Fail', t:{t:'Action'}, i:'If_Fail', c:[]});
      tree.push({q:'If Succeed', t:{t:'Action'}, i:'If_Succeed', c:[]});
      return tree;
    }else{
      console.warn(currentAnswer);
      return [];
    }
}

export function checkThatSmartContractExists(currentList, tgt){
  if (currentList.sc[tgt]){
    return true;
  }
  return false;
}

export function msg(txt){return txt}
// export function msg(txt){return {t:'formula', x:[{t:'s',v:txt}], o:{t: 's', v: txt}, r:{t:'Text String'}, y:{}};}
export function aPanel(screenPath){
  var txt = screenPath.filter((aP, index)=>{
    return +index < 4;
  })
  return {t:'formula', x:[{t:'pa',v:txt}], o:{t: 'pa', v: txt}, r:{t:'Panel'}, y:{}};
}

export function aPopUp(currentList){
  var txt = '';
  if (currentList.pu){
    var keys = Object.keys(currentList.pu);
    if (keys.length > 0){
      txt = keys[0];
    }
  }
  return {t:'formula', x:[{t:'pu',v:txt}], o:{t: 'pu', v: txt}, r:{t:'PopUp'}, y:{}};  
}

export function anAlert(currentList, screenPath){
  var txt = [];
  if (screenPath[4] === 'al'){
    txt = getBefore(screenPath, 6);    
  }else{

    var tgt = 'fe';
    if (screenPath.length > 0 && screenPath[0] === 'pu'){
      tgt = screenPath[0];
    }

    var frontEnds = currentList[tgt];
    var frontEndKeys = Object.keys(frontEnds);
    for (var i = 0; i < frontEndKeys.length; i++){
      var screens = frontEnds[frontEndKeys[i]]._s;
      if (screens){
        var screenKeys = Object.keys(screens);
        for (var j = 0; j < screenKeys.length; j++){
          var alerts = screens[screenKeys[j]].al;
          var alertKeys = Object.keys(alerts);
          if (alertKeys.length > 0){
            txt = [tgt, frontEndKeys[i], '_s', screenKeys[j], 'al', alertKeys[0]];
            break;
          }
        }        
      }
      if (txt.length > 0){
        break;
      }
    }    
  }

  return {t:'formula', x:[{t:'al',v:txt}], o:{t: 'al', v: txt}, r:{t:'Alert'}, y:{}};
}

export function changeOfScreen(currentList, path){
  var feSet = currentList.fe;
  var feKeys = Object.keys(feSet);
  var changeTo = '';
  if (feKeys.length > 0){
    changeTo = feKeys[0];
    if (feKeys.length > 1){
      if (path[1] === changeTo){
        changeTo = feKeys[1];
      }
    }
  }
  return {t:'formula', x:[{t:'scr',v:changeTo}], o:{t: 'scr', v:changeTo}, r:{t:'Screen'}, y:{}};
}

export function changeOfMusic(currentList){
  var changeTo = '';
  var feSet = currentList.mu;
  if (feSet){
    var feKeys = Object.keys(feSet);
    if (feKeys.length > 0){
      changeTo = feKeys[0];
    }    
  }
  return {t:'formula', x:[{t:'mus',v:changeTo}], o:{t: 'mus', v:changeTo}, r:{t:'Music'}, y:{}};
}





export function getDefaultTypeAndPointerFromItem(item){
  var iT = TypeEvaluation.getInputTypeFromInput(item);
  var i;

  if (iT.t === 'Text String'){
    i = 'newValueString';
  }else if (iT.t === 'Integer'){
    i = 'newValueInteger';
  }else if (iT.t === 'UInteger'){
    i = 'newValueUInteger';
  }else if (iT.t === 'Decimal'){
    i = 'newValueDecimal';
  }else if (iT.t === 'Address'){
    i = 'newValueAddress';
  }else if (iT.t === 'Transaction'){
    i = 'newValueTransaction';
  }else if (iT.t === 'ListType'){
    i = 'newValueList';
  }else{
    console.warn(iT);
  }

  return {i, iT};
}

export function findEmptyNamePath(screens, prefix, locator, minValue){
  var screenKeys = Object.keys(screens);
  var screenNameNos = minValue;
  var candidateName;
  do{
    candidateName = prefix + screenNameNos;
    var alreadyUsed = false; 
    for (var i = 0; i < screenKeys.length; i++){
      var pathResult = CoreFns.goDownPath(screens, [screenKeys[i]].concat(locator), 0);
      if (pathResult === candidateName){
        alreadyUsed = true;
        break;
      }
    }
    screenNameNos ++;
  }while(alreadyUsed);
  return candidateName
}


export function doInputActionsFn(screenPath, organicChanges, currentList, userID){

  var path = screenPath.concat(['x']);
  return function(ref){
    var changesText = getRawContents(ref.current, currentList, path, screenPath, userID);
    organicChanges(changesText);
  }    
}

export function highlight(tgtId){
	var newTgt = document.getElementById(tgtId);

	if (newTgt){
		if (newTgt.tagName === 'IMG' || newTgt.tagName === 'INPUT' || (newTgt.tagName === 'SPAN' && newTgt.id)){		
			newTgt.style.borderColor = '#CCC';
			newTgt.style.borderWidth = '1px';
			newTgt.style.borderStyle = 'solid';
		}
	}

}

export function addCellZPiece(idCell1, tableType, words, oc){
  var cellContents = [{t:'br'}];
  if (words){
    cellContents = words;
  }
  var s = {padding:{t:'px',v:10}, textAlign:{t:'align',v:'left'}, widthWeight:{t:'int',v:2}};
  if (tableType === 1 || tableType === 2){
    s.borderColor = {t: 'raw', v: 'rgb(0, 0, 0)'}
    s.borderWidth = {t:'px', v:1};
    s.borderStyle = {t: 'style', v:'solid'};
    if (tableType === 1){
      s.textAlign = {t:'align',v:'center'}
    }
  }
  var j = {n:'1',s,x:cellContents};
  if (oc){
    j.oc = oc;
  }
  var y = {j,_na:'Cell ' + idCell1};
  return {t:'w',w:['as', idCell1],n:y};
}

export function checkStyleMatchObject(styleA,styleB){
    var keysA = Object.keys(styleA);
    var keysB = Object.keys(styleB);
    if (keysA.length !== keysB.length){
      return false;
    }else{
      for (var j = 0; j < keysA.length; j++){
        if (styleA[keysA[j]] !== styleB[keysA[j]]){
          return false;
        }
      }
    }
    return true;

}

export function compareStyleEqualityList(a,b){
  if (a.length !== b.length){
    return false;
  }

  for (var i = 0; i < a.length; i++){
    var aT = a[i].t;
    var haveFound = false;
    for (var j = 0; j < b.length; j++){
      if (b[j].t === aT){
        if (b[j].v === a[i].v){
        }else{
          return false;
        }
        haveFound = true;
        break;
      }
      if (!haveFound){
        return false;
      }
    }
  }
  return true;
}

export function getTotalWeightAndWeightsOfARow(ele, currentList, internalVariables, width, height, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains){
    var totalWeight = 0;
    var widthWeights = [];
    var entityStore = CoreFns.goDownPath(currentList, ['as'], 0);
    for (var i5 = 0; i5 < ele.childNodes.length; i5++){
      var aCell = ele.childNodes[i5];
      var nodeId = aCell.id;
      var upwardInfo = [];
      var aWeight = 2;
      if (nodeId !== '_g' && nodeId !== ''){
        var thisPath = ['as', nodeId];
        aWeight = StyleFunctions.convertValToActVal(entityStore[nodeId].s.widthWeight, 'widthWeight', thisPath.concat(['s', 'widthWeight']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      }
      widthWeights.push(aWeight);
      totalWeight += aWeight;
    }
    var setOut = [];
    for (var i = 0; i < widthWeights.length; i++){
      var perc = ((100 * widthWeights[i]) / totalWeight) + '%';
      setOut.push(perc);
    }
      var childNodes = ele.childNodes;
      childNodes.forEach((aChild, index)=>{
        aChild.style.width = setOut[index];
      })
}

export function compareStyleEquality(a,b){
  var matchPieces = ['B','C','D','H','I','U','F','G'];
  for (var i = 0; i < matchPieces.length; i++){
    var aM = a[matchPieces[i]];
    var bM = b[matchPieces[i]];
    if (!aM && !bM){
    }else if (aM === bM){

    }else{
      return false;
    }
  }
  return true;
}

function splitTextIntoBinary(text){
  var output = [];
  for (var i10 = 0; i10 < text.length; i10++){
    if (text.charCodeAt(i10) === 8203){
    }else{
      output.push({u:text.substr(i10,1)});
    }
  }
  return output;
}



function getRawContents(ref, currentList, path, screenPath, userID){

  var subChanges = [];

  function deriveChildren(list, sets){

    list.forEach((aC, index)=>{
      var thisPath = ['as', aC.id];
      var tagName = aC.tagName;
      if (!tagName){
        var v = aC.textContent;
          if (v.length > 0){
            sets.push({t:'tb', v:splitTextIntoBinary(v)})
          }
      }else if (tagName === 'DIV'){
        if (aC.id === '_highlightedCorner'){
        }else{
          sets.push({t:'h',n:tagName});
          deriveChildren(aC.childNodes,sets);  
        }
      }else if (tagName === 'TABLE'){
        sets.push({t:'a',n:tagName,i:aC.id});
        var getEle = CoreFns.goDownPath(currentList, thisPath);
        if (getEle.s.tableType.v === 6 ){
        }else{
          var cExtra = getRawContents(aC.childNodes[0], currentList, ['as', aC.id, 'x'], screenPath, userID);
          subChanges = subChanges.concat(cExtra);
        }
      }else if (tagName === 'TR' || tagName === 'TD'){
        sets.push({t:'a',n:tagName,i:aC.id});
        if (aC.id !== '_g'){
          var cExtra1 = getRawContents(aC, currentList, ['as', aC.id,'x'], screenPath, userID);
          subChanges = subChanges.concat(cExtra1);
        }
      }else if (tagName === 'BR'){
        sets.push({t:'br'});
      }else if (tagName === 'B' || tagName === 'U' || tagName === 'I'){
        // if (aC.childNodes.length === 0){
        //   aC.parentNode.removeChild(aC);
        // }else{
          sets.push({t:tagName,z:1});
          deriveChildren(aC.childNodes,sets);  
          sets.push({t:tagName,z:0});
        // }
      }else if (tagName === 'SPAN'){
        if (aC.id){
          sets.push({t:'a',n:tagName,i:aC.id});
        // }else if (aC.childNodes.length === 0){
        //   aC.parentNode.removeChild(aC);
        }else{
          var style = aC.style;
          if (style['0'] === 'caret-color' || style['0'] === 'color' || style['0'] === 'background-image'){
            var color1 = style[style['0']];
            sets.push({t:'C',v:color1,z:1});
            deriveChildren(aC.childNodes,sets);
            sets.push({t:'C',v:color1,z:0});
          }else if (style['0'] === 'background-color'){
            var background = style['background-color'];
            sets.push({t:'D',v:background,z:1});
            deriveChildren(aC.childNodes,sets);
            sets.push({t:'D',v:background,z:0});
          }else if (style['0'] === 'font-size'){
            var xx = style.fontSizeP;
            if (!xx){
              xx = style.fontSize;
            }
            sets.push({t:'F',v:xx,z:1});
            deriveChildren(aC.childNodes,sets);
            sets.push({t:'F',v:xx,z:0});
          }else if (style['0'] === 'font-family'){
            var ff = style['font-family'];
            if (ff.indexOf('"') === 0){
              ff = ff.split('"')[1];
            }
            sets.push({t:'G',v:ff,z:1});
            deriveChildren(aC.childNodes,sets);
            sets.push({t:'G',v:ff,z:0});
          }else if (style['0'] === 'text-align'){
            deriveChildren(aC.childNodes,sets);
          }else if (tagName === 'CANVAS'){ //this exists for qrcode. 
          }else if (tagName === 'font-weight'){
            sets.push({t:'B',z:1});
            deriveChildren(aC.childNodes,sets);  
            sets.push({t:'B',z:0});
          }else{
            var rr = aC.textContent;
              if (rr.length > 0){
                sets.push({t:'tb', v:splitTextIntoBinary(rr)})
              }

          }
        }
      }else if (tagName === 'FONT'){
        var face = aC.face;
        var color11 = aC.color;
        var backgroundColor = aC.backgroundColor;
        if (face){
          sets.push({t:'G',v:face,z:1});
        }
        if (backgroundColor){
          sets.push({t:'D',v:backgroundColor,z:1});
        }
        if (color11){
          sets.push({t:'C',v:color11,z:1});
        }
        deriveChildren(aC.childNodes,sets);
        if (color11){
          sets.push({t:'C',v:color11,z:0});
        }
        if (backgroundColor){
          sets.push({t:'D',v:backgroundColor,z:0});
        }
        if (face){
          sets.push({t:'G',v:face,z:0});
        }
      // }else if (tagName === 'TBODY'){
      //   deriveChildren(aC.childNodes,sets);
      }else{
        console.log(aC);
        console.log(tagName);
      }

    })

  }
  var sets = [];
  deriveChildren(ref.childNodes, sets);

  var current = {B:'',I:'',U:'',C:'',D:'',F:'',G:''};
  var pieces = [];
  sets.forEach((aSet, index)=>{
    if (aSet.t === 'br' || aSet.t === 'h' || aSet.t === 'a'){
      pieces.push(aSet);
    }else if (aSet.t === 't' || aSet.t === 'tb'){
      var s = {};
      var sP = ['B','I','U','C','D','F','G'];
      sP.forEach((aP, index)=>{
        if (current[aP]){
          s[aP] = current[aP];
        }
      })
      var vv = aSet.v;
      if (aSet.t === 't'){
        for (var i5 = 0; i5 < vv.length; i5++){
          pieces.push({t:'t', v:vv.substr(i5, 1), s})
        }        
      }else{
        pieces.push({t:'tb', v:vv, s});
      }
    }else if (aSet.t === 'B' || aSet.t === 'U' || aSet.t === 'I'){
      if (aSet.z){
        current[aSet.t] = aSet.t;
      }else{
        current[aSet.t] = '';
      }
    }else if (aSet.t === 'C' || aSet.t === 'D' || aSet.t === 'F' || aSet.t === 'G'){
      if (aSet.z){
        current[aSet.t] = aSet.v;
      }else{
        current[aSet.t] = '';
      }
    }
  })

  var input = CoreFns.goDownPath(currentList, path, 0);

  var changesText = LevenshteinText(input, pieces, path);
  return changesText.concat(subChanges);

}


export function isInside(considerWhat, cummulativeCount, textLength){
	if (considerWhat >= cummulativeCount && considerWhat <= cummulativeCount + textLength){
		return true;
	}
	return false;
}


export function isDivOrTableCell(element){
  if(element){
    return element.tagName === 'DIV' || element.tagName === 'TD'; 
  }
  return false;
}

export function goUpSeeGotTD(aN){
    if (aN){
      if (aN.tagName === 'TD'){
        return aN.id;
      }else{
        return goUpSeeGotTD(aN.parentNode);
      }
    }else{
      return false;
    }
  }


export function limit(){ return {x:[{t:'f',v:91}], o:{t:'f',i:91, v:[]}, r:{t:'Limit'}, y:{}}  }

export function coverNodeWithAttributes(item, attribs, insetWidth, insetHeight){
  for (var j = 0; j < attribs.length; j++){
    var anAttrib = attribs[j];
    if (anAttrib.t === 'B' || anAttrib.t === 'I' || anAttrib.t === 'U'){
      var element = document.createElement(anAttrib.t);
      element.appendChild(item);
      item = element;
    }else if (anAttrib.t === 'C' || anAttrib.t === 'D' || anAttrib.t === 'F' || anAttrib.t === 'G'){
      var element1 = document.createElement('span');
      if (anAttrib.t === 'C'){
        if (anAttrib.v.indexOf('linear-gradient') === 0){
          element1.style.backgroundImage = anAttrib.v;
          element1.className = 'gradientText';
        }else{
          element1.style.color = anAttrib.v;
        }
      }else if (anAttrib.t === 'D'){
        element1.style['background-color'] = anAttrib.v;
      }else if (anAttrib.t === 'F'){
        element1.style['font-size'] = convertFontSize(anAttrib.v, insetWidth, insetHeight);
        element1.style['fontSizeP'] = anAttrib.v;
      }else if (anAttrib.t === 'G'){
        element1.style['font-family'] = anAttrib.v;
      }
      element1.appendChild(item);
      item = element1;
    }
  }
  return item;
}

export function attribValue(attribs, reference){
  for (var i = 0; i < attribs.length; i++){
    if (attribs[i].t === reference){
      return attribs[i].v;
    }
  }
  return '';
}

export function resolveSingular(v, insetWidth, insetHeight){
  if (!v){
    v = '';
  }
  var vh = v.indexOf('vh');
  var vw = v.indexOf('vw');
  if (vh > 0){
    var before = v.substr(0, vh);
    return (before * insetHeight/100) + 'px';
  }else if (vw > 0){
    var before1 = v.substr(0, vw);
    return (before1 * insetWidth / 100) + 'px';
  }
  return v;
}
export function convertFontSize(v, insetWidth, insetHeight){
  if (v.indexOf('calc(') === 0){
    var inside = v.substr(5, v.length - 6);
    var insideArray = inside.split(' + ');
    return 'calc(' + resolveSingular(insideArray[0], insetWidth, insetHeight) + ' + ' + resolveSingular(insideArray[1], insetWidth, insetHeight) + ')';
  }else{
    return resolveSingular(v, insetWidth, insetHeight);
  }
}


export function newAttrib(attribs, reference, newVal){
  var sAttribs = attribs.filter((anAttrib, index)=>{
    return anAttrib.t !== reference;
  })            
  if (newVal){
    sAttribs.push({t:reference, v:newVal});
  }
  return sAttribs;        
}

export function drillToTextNode(node){
  if (!node.tagName){
    return node;
  }else{
    return drillToTextNode(node.childNodes[0]);
  }
}

export function getBefore(value, i){
    return value.filter((aVal, index)=>{
      return +index < i;
    })
  }

export function getAfterIncl(value, i){
    return value.filter((aVal, index)=>{
        return +index >= i;
      })
  }



